import { User } from '@supabase/supabase-js';
import { LearningTrack } from '../../shared/types/learning-track.type';
import { IUser, UserRole } from '../models/auth.model';

export class AuthMapper {
  /**
   * Safely merges the Supabase Auth User with their public profile/role data.
   *
   * The fallback role is `incomplete_student`, the least-privileged one: a user
   * who reaches onboarding by mistake can recover, whereas one wrongly handed
   * `teacher` gets the admin shell and a wall of RLS errors. This used to
   * default to `teacher`, a second copy of the bug fixed in
   * `fetchUserProfile()` (§16 R4) that would have silently re-created it for
   * any caller that omitted the role.
   */
  static toUserModel(authUser: User, profileData?: { role?: UserRole; name?: string; phone?: string; gradeId?: string; avatarUrl?: string; teacherId?: string; teacherName?: string; subscriptionStatus?: string; subscriptionExpiresAt?: string | null; learningTrack?: LearningTrack | null; emailConfirmationRequired?: boolean } | null): IUser {
    return {
      id: authUser.id,
      email: authUser.email ?? '',
      role: profileData?.role ?? 'incomplete_student',
      teacherId: profileData?.teacherId,
      teacherName: profileData?.teacherName,
      subscriptionStatus: profileData?.subscriptionStatus,
      subscriptionExpiresAt: profileData?.subscriptionExpiresAt,
      name: profileData?.name,
      phone: profileData?.phone,
      gradeId: profileData?.gradeId,
      avatarUrl: profileData?.avatarUrl,
      learningTrack: profileData?.learningTrack,
      emailConfirmationRequired: profileData?.emailConfirmationRequired,
    };
  }
}
